import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { GenericObservationDeviceLinkNoData } from 'health/observations/generics';
import LogPeakFlow from './log/LogPeakFlow';
import { PeakFlow } from 'shared/fullColorIcons';

const typeDefinition = {
  type: ObservationType.PeakFlow,
  typeUnitMap: {
    [ObservationType.PeakFlow]: Unit.LiterPerMinute
  },
  unitLabelMap: {
    [Unit.LiterPerMinute]: local.units.litersPerMinute
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.peakFlow,
  backPath: { to: routePaths.health },
  centerElement: local.observation.peakFlow.title,
  noDataText: local.observation.peakFlow.noDataText,
  iconSymbol: PeakFlow,
  renderNoDataComponent: (props) => props && <GenericObservationDeviceLinkNoData message={props.config.noDataText} />,
  // eslint-disable-next-line react/no-multi-comp
  renderLogComponent: (props) => props && <LogPeakFlow {...props} />
};
